module.exports = __webpack_public_path__ + "cfa74fefcdda78411934bda0402b911c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GT.svg
// module id = W6Iy
// module chunks = 0